import { useResetSession } from '@ms/yammer-search-telemetry';
import { usePrevious } from '@ms/yammer-web-core-ui/dist/util/usePrevious';
import { useEffect } from 'react';

import { useLocationSearchResultsParameters } from './useLocationSearchResultsParameters';

export const useEndActiveSession = (): void => {
  const { searchText } = useLocationSearchResultsParameters();
  const previous = usePrevious(searchText);
  const resetSession = useResetSession();

  useEffect(() => {
    if (!searchText && !!previous) {
      resetSession('globalSearchSession');
    }
  }, [searchText, previous, resetSession]);
};
